
class ProductComparisonTable {
  constructor(container) {
    this.container = container;
    this.toggleButton = this.container.querySelector('.product-comparison-table__toggle');
    this.expandableRows = this.container.querySelector('.product-comparison-table__expandable-rows');
    
    if (!this.toggleButton || !this.expandableRows) return;

    this.init();
  }

  init() {
    this.toggleButton.addEventListener('click', () => this.toggleRows());
  }

  toggleRows() {
    const isExpanded = this.toggleButton.getAttribute('aria-expanded') === 'true';
    
    if (isExpanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  expand() {

    this.expandableRows.style.maxHeight = `${this.expandableRows.scrollHeight}px`;
    this.toggleButton.setAttribute('aria-expanded', 'true');
    this.toggleButton.textContent = this.toggleButton.dataset.seeLess;
    this.container.classList.add('is-expanded');
  }

  collapse() {
    this.expandableRows.style.maxHeight = '0px';
    this.toggleButton.setAttribute('aria-expanded', 'false');
    this.toggleButton.textContent = this.toggleButton.dataset.seeMore;
    this.container.classList.remove('is-expanded');
  }
}


document.addEventListener('DOMContentLoaded', () => {
  const tables = document.querySelectorAll('.product-comparison-table');
  tables.forEach(table => new ProductComparisonTable(table));
});

